module.exports = __webpack_public_path__ + "img/mersthamfc.a6699ea0.png";